import { url } from 'inspector';
import moment from 'moment';
import { idText } from 'typescript';

export default class AdminOrganizationModel {
  id: string;
  name: string;
  abbreviation: string;
  procedureRules: string;
  reviewCount: number;
  orgId: string;
  hexColor: string;
  url: string;
  hyperLinkTitle: string;
  lwb: boolean;
  createdAt?: string;
  updatedAt?: string;
  imageId?: string;
  imageInfo?: any;
  position?: number;

  constructor(data?: any) {
    this.id = data?.id || undefined;
    this.name = data?.name || undefined;
    this.abbreviation = data?.abbreviation || undefined;
    this.procedureRules = data?.procedureRules || undefined;
    this.reviewCount = data?.reviewCount || 0;
    this.orgId = data?.orgId || undefined;
    this.hexColor = data?.hexColor || undefined;
    this.url = data?.url || undefined;
    this.imageInfo = data?.imageInfo ?? undefined;
    this.hyperLinkTitle = data?.hyperLinkTitle || undefined;
    this.lwb = data?.lwb || 0;
    this.createdAt = data?.createdAt ? moment.unix(data.createdAt).format('ll') : undefined;
    this.updatedAt = data?.updatedAt ? moment.unix(data.updatedAt).format('ll') : undefined;
    this.imageId = data?.imageId || undefined;
    this.position = data?.position || undefined;
  }
}
